import { render, staticRenderFns } from "./ReceiptScanner.vue?vue&type=template&id=8efb4bde&scoped=true"
import script from "./ReceiptScanner.vue?vue&type=script&lang=js"
export * from "./ReceiptScanner.vue?vue&type=script&lang=js"
import style0 from "./ReceiptScanner.vue?vue&type=style&index=0&id=8efb4bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efb4bde",
  null
  
)

export default component.exports